import React from "react";

const PartnerOpportunities = () => {
  return (
    <div>
      <h1>Opportunities</h1>
    </div>
  );
};

export default PartnerOpportunities;
